<template>
  <vue-final-modal
    v-slot="{ close }"
    esc-to-close
    class="vfm-gallery"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="vfm__inner">
      <div class="vfm-gallery__container">
        <div class="h3 title" v-html="title" />
        <div class="list__wrap">
          <FloorPlan
            class="plan"
            :img="img"
            :points="points"
            @flatClick="close"
          />
        </div>
      </div>
      <a href="javascript:void(0)" class="vfm__close" @click="close"
        ><Icon icon="close"
      /></a>
    </div>
  </vue-final-modal>
</template>

<script>
import FloorPlan from "@/components/FloorPlan.vue";

export default {
  components: {
    FloorPlan,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    img: {
      require: false,
    },
    points: {
      require: false,
    },
  },
  methods: {
    beforeOpen() {
      document.querySelector(".header").classList.add("overflow");
    },
    closed() {
      document.querySelector(".header").classList.remove("overflow");
    },
  },
};
</script>

<style scoped src="@css/popup.css"></style>
<style scoped lang="scss">
.title {
  position: relative;
  z-index: 1;
  margin-right: 60px;
}

.plan {
  :deep(.tooltip__area) {
    polygon {
      opacity: 1;
      fill: #ff002033;

      &:hover {
        opacity: 1;
        fill: #ff002066;
      }

      &.current {
        fill: #ff002092;
        pointer-events: none;
      }
    }
  }
}

.vfm__container {
  overflow-x: hidden;
}
</style>
